// Labels the settings page needs on top of translations.ts: card titles in
// sentence case, row hints and the sheet titles.
export const settingsCopy = {
  fr: {
    title: "Mon profil",
    countrySearch: "Rechercher un pays",
    countryNotFound: "Aucun pays trouvé",
    choose: "Choisir",
    subtitle: "Vos informations, vos préférences et la gestion de votre compte.",
    edit: "Modifier",
    change: "Changer",
    open: "Ouvrir",
    notProvided: "Non renseigné",
    accountActive: "Compte actif",
    accountInactive: "Compte désactivé",
    paidValidated: "Paiements activés",
    roles: {
      collector: "Collecteur",
      moderator: "Modérateur",
      admin: "Administrateur",
      accountant: "Comptable",
      super_admin: "Super admin",
    },
    preferencesTitle: "Préférences",
    interfaceLanguage: "Langue de l'interface",
    interfaceLanguageHint: "La langue des menus et des pages sur cet appareil.",
    theme: "Thème",
    themeLight: "Clair",
    themeDark: "Sombre",
    languagesTitle: "Mes langues",
    languagesHint: "Les langues que vous parlez et dans lesquelles vous contribuez.",
    noLanguage: "Aucune langue choisie",
    languageFields: {
      spokenLanguages: "Langues parlées",
      contributionLanguages: "Langues de contribution",
      moderationLanguages: "Langues de modération",
    },
    accountTitle: "Compte",
    password: "Mot de passe",
    passwordHint: "Changez le mot de passe de votre compte.",
    passwordSheetDesc: "Saisissez votre mot de passe actuel, puis le nouveau deux fois.",
    newPasswordEmpty: "Saisissez un nouveau mot de passe.",
    myData: "Mes données personnelles",
    myDataHint: "Export de vos données et vos droits (RGPD).",
    privacySheetDesc: "Recevez une copie de vos données et consultez vos droits.",
    rightsTitle: "Vos droits",
    adminSpace: "Espace d'administration",
    logoutHint: "Fermer votre session sur cet appareil.",
    dangerTitle: "Supprimer mon compte",
    profileSheetTitle: "Modifier mes informations",
    profileSheetDesc: "Ces informations servent à vous identifier et à vous joindre.",
  },
  en: {
    title: "My profile",
    countrySearch: "Search a country",
    countryNotFound: "No country found",
    choose: "Choose",
    subtitle: "Your details, your preferences and your account.",
    edit: "Edit",
    change: "Change",
    open: "Open",
    notProvided: "Not provided",
    accountActive: "Active account",
    accountInactive: "Deactivated account",
    paidValidated: "Payouts enabled",
    roles: {
      collector: "Collector",
      moderator: "Moderator",
      admin: "Administrator",
      accountant: "Accountant",
      super_admin: "Super admin",
    },
    preferencesTitle: "Preferences",
    interfaceLanguage: "Interface language",
    interfaceLanguageHint: "The language of menus and pages on this device.",
    theme: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    languagesTitle: "My languages",
    languagesHint: "The languages you speak and contribute in.",
    noLanguage: "No language selected",
    languageFields: {
      spokenLanguages: "Spoken languages",
      contributionLanguages: "Contribution languages",
      moderationLanguages: "Moderation languages",
    },
    accountTitle: "Account",
    password: "Password",
    passwordHint: "Change your account password.",
    passwordSheetDesc: "Enter your current password, then the new one twice.",
    newPasswordEmpty: "Enter a new password.",
    myData: "My personal data",
    myDataHint: "Export your data and see your rights (GDPR).",
    privacySheetDesc: "Get a copy of your data and read about your rights.",
    rightsTitle: "Your rights",
    adminSpace: "Administration space",
    logoutHint: "End your session on this device.",
    dangerTitle: "Delete my account",
    profileSheetTitle: "Edit my details",
    profileSheetDesc: "These details identify you and let us reach you.",
  },
};

export type SettingsCopy = (typeof settingsCopy)["fr"];

export const settingsCopyFor = (lang: string): SettingsCopy => settingsCopy[lang === "en" ? "en" : "fr"];
